"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));

var _utils = require("./utils");

var _utils2 = require("../../../utils");

var _Legend = _interopRequireDefault(require("./Legend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ProjectionChart(props) {
  var min = props.min,
      max = props.max,
      data = props.data,
      dataExternal = props.dataExternal,
      height = props.height,
      className = props.className,
      yAxisFormat = props.yAxisFormat,
      tooltipFormat = props.tooltipFormat,
      yTitle = props.yTitle,
      yearsText = props.yearsText,
      topLabel = props.topLabel,
      bottomLabel = props.bottomLabel,
      middleLabel = props.middleLabel,
      legendLabels = props.legendLabels,
      showLegend = props.showLegend,
      colorScheme = props.colorScheme;
  var containerClassName = (0, _utils2.getClassNames)('projection-chart-container', _defineProperty({}, "highcharts-".concat(colorScheme), colorScheme));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/_react.default.createElement(_highchartsReactOfficial.default, {
    containerProps: {
      className: (0, _utils2.getClassNames)('highcharts-projection-chart', className)
    },
    options: (0, _utils.getBarChartOptions)(min, max, data, dataExternal, height, yAxisFormat, tooltipFormat, {
      yearsText: yearsText,
      yTitle: yTitle,
      topLabel: topLabel,
      bottomLabel: bottomLabel,
      middleLabel: middleLabel
    })
  }), showLegend && /*#__PURE__*/_react.default.createElement(_Legend.default, {
    dataExternal: dataExternal,
    legendLabels: legendLabels
  }));
}

ProjectionChart.propTypes = {
  /** Data (type 'area') to be shown on chart */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    data: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.number)), _propTypes.default.arrayOf(_propTypes.default.number)])).isRequired
  })),

  /** External data with different types to be shown on chart */
  dataExternal: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    data: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.number)), _propTypes.default.arrayOf(_propTypes.default.number)])).isRequired
  })),

  /** Height of chart */
  height: _propTypes.default.number,

  /** Formats of Y axis label */
  yAxisFormat: _propTypes.default.func,

  /** Formats of tooltip */
  tooltipFormat: _propTypes.default.func,

  /** Max value of Y axis */
  min: _propTypes.default.number,

  /** Max value of Y axis */
  max: _propTypes.default.number,

  /** Title to be shown on Y axis */
  yTitle: _propTypes.default.string,

  /** Name for top line */
  topLabel: _propTypes.default.string,

  /** Name for bottom line */
  bottomLabel: _propTypes.default.string,

  /** Name for middle line */
  middleLabel: _propTypes.default.string,

  /** Label to be shown on X axis */
  yearsText: _propTypes.default.string,

  /** The custom color scheme (e.g. 'positiveAndNegative') */
  colorScheme: _propTypes.default.string,

  /** The legend labels to be shown */
  legendLabels: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Whether the legend should be shown */
  showLegend: _propTypes.default.bool,
  className: _propTypes.default.string
};
ProjectionChart.defaultProps = {
  min: undefined,
  max: undefined,
  data: [],
  dataExternal: [],
  yTitle: '',
  topLabel: '',
  bottomLabel: '',
  middleLabel: '',
  height: undefined,
  yAxisFormat: function yAxisFormat(label) {
    return label;
  },
  tooltipFormat: function tooltipFormat(_ref) {
    var y = _ref.point.y,
        name = _ref.series.name;
    return "".concat(name, ": ").concat(y.toLocaleString('en-US', {
      maximumFractionDigits: 2
    }));
  },
  colorScheme: null,
  legendLabels: [],
  showLegend: false,
  className: '',
  yearsText: 'Years'
};
var _default = ProjectionChart;
exports.default = _default;